<template>
  <div class="card">
    <div class="card-content">
      <question-title :question="question" class="mb1"></question-title>

      <div class="select mt1 is-fullwidth">
        <select v-model="location" @change="setProviders">
          <option disabled>Location</option>
          <option v-for="location in locations">{{ location }}</option>
        </select>
      </div>

      <div class="select mt1 is-fullwidth">
        <select v-model="provider" @change="recordAnswer">
          <option disabled>Provider</option>
          <option v-for="name in providers">{{ name }}</option>
        </select>
      </div>

      <next-button :id="question.id" :choice="choice"></next-button>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import baseQuestion from "./baseQuestion";

const locationDefault = "Location";
const providerDefault = "Provider";

export default {
  name: "location",

  mixins: [baseQuestion],

  data() {
    return {
      location: locationDefault,
      provider: providerDefault,
      providers: []
    };
  },

  computed: {
    locations() {
      return _.map(this.question.fields, o => o.location);
    }
  },

  watch: {
    choice(newValue) {
      if (_.has(newValue, "location")) {
        this.location = newValue.location;
      }
      if (_.has(newValue, "provider")) {
        this.provider = newValue.provider;
      }
      this.setProviders(null, true);
    }
  },

  methods: {
    setProviders(e, overrideDefault = false) {
      const providers = _.filter(
        this.question.fields,
        o => o.location === this.location
      )[0].provider;
      if (!overrideDefault) {
        this.provider = providerDefault;
      }
      this.providers = _.map(providers, o => o.name);
    },
    recordAnswer() {
      if (
        this.location !== locationDefault &&
        this.provider !== providerDefault
      ) {
        this.choice = { location: this.location, provider: this.provider };
        this.$store.dispatch("interview/setNext", true);
      } else {
        this.$store.dispatch("interview/setNext", false);
      }
    }
  }
};
</script>
